import React, { useEffect, useState } from 'react';

// Check if token looks like a JWT (has 3 parts separated by dots)
function isJWTFormat(token) {
  if (!token) return false;
  const parts = token.split('.');
  return parts.length === 3;
}

// Get token from URL query params
function getTokenFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('token');
}

function TokenGuard({ children }) {
  const [isAuthorized, setIsAuthorized] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = getTokenFromURL();

    // Check token from URL
    if (token) {
      if (isJWTFormat(token)) {
        // Store JWT token for API calls - backend will validate
        localStorage.setItem('token', token);
        sessionStorage.setItem('access_token', token);
        setIsAuthorized(true);
      } else {
        setError('Invalid token format');
        setIsAuthorized(false);
      }
    } else {
      // Check if already authenticated in this session
      const storedToken = sessionStorage.getItem('access_token') || localStorage.getItem('token');
      if (storedToken && isJWTFormat(storedToken)) {
        setIsAuthorized(true);
      } else {
        setError('Missing token');
        setIsAuthorized(false);
      }
    }
  }, []);

  // Loading state
  if (isAuthorized === null) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #e0e0e0',
          borderTop: '4px solid #3498db',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // Not authorized
  if (!isAuthorized) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '40px',
          borderRadius: '12px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔒</div>
          <h1 style={{ color: '#e74c3c', marginBottom: '8px', fontSize: '24px' }}>Access Denied</h1>
          <p style={{ color: '#666', marginBottom: '0' }}>{error || 'You do not have permission to access this dashboard.'}</p>
        </div>
      </div>
    );
  }

  // Authorized - render children (backend will validate on API calls)
  return children;
}

export default TokenGuard;
